<template>
  <highliter
    v-model="section.name"
    :dublicate="section"
    :dublicate-deep="parentUID"
    class="highlight-element"
    section-type="element"
    @delete="$emit('delete')"
    @dublicate="$emit('dublicate')"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @add-subject="$emit('add-subject')"
    @click.stop.native="sectionSettings('horizontalLine')"
  >
    <div
      :data-sid="section.sid"
      :data-uid="section.uid"
    >
      <Template :section="section">
        <div
          class="p-[20px]"
          :class="[{'element-hidden': !visability('horizontalLine')}, `--${section.sid}-divider`]"
        >
          <div v-if="section.options.content.horizontalLine.pressetID === 1">
            <div
              :style="{...shadowDivider}"
              class="shadow-container"
            />
          </div>
          <div v-if="section.options.content.horizontalLine.pressetID === 2">
            <div :style="backgroundDivider" />
          </div>
          <div
            v-else
            :style="{borderRadius: section.options.content.horizontalLine.pilled ? '25rem' : 0}"
            class="overflow-hidden"
          >
            <div
              :style="dividerLineStyle"
              class="headline-divider w-100"
            />
          </div>
        </div>
      </Template>
    </div>
  </highliter>
</template>

<script>
import SectionMixin from '@builder/components/mixins/SectionMixin'
import Highliter from '@builder/components/builder/utils/Highliter'
import Template from './Template'
import BorderMixin from '@/components/mixins/BorderMixin'
import _ from 'lodash'

export default {
  name: 'FeaturedItems1',

  components: {Template, Highliter},

  mixins: [SectionMixin, BorderMixin],

  computed: {
    dividerConfig () {
      return this.section.options.content.horizontalLine
    },
    width () {
      return parseInt(_.get(this.dividerConfig.width, this.resolutioner, _.get(this.dividerConfig.width, 'lg', this.dividerConfig.width || 2)))
    },
    lineGradient () {
      if (this.dividerConfig.pressetID !== 0 || this.dividerConfig.backgroundType !== 'gradient' || !Array.isArray(this.dividerConfig.backgroundGradient)) {
        return null
      }

      const stops = this.dividerConfig.backgroundGradient
        .filter(item => item && item.color)
        .map(item => `${item.color} ${item.position ?? 0}%`)

      if (!stops.length) {
        return null
      }

      const direction = Number(this.dividerConfig.gradientDirection)
      return `linear-gradient(${Number.isFinite(direction) ? direction : 90}deg,${stops.join(',')})`
    },
    lineColor () {
      if (this.lineGradient && this.dividerConfig.backgroundGradient[0]?.color) {
        return this.dividerConfig.backgroundGradient[0].color
      }

      return this.dividerConfig.color || '#AEB1B4'
    },
    dividerLineStyle () {
      const style = {
        borderTopStyle: `${this.dividerConfig.style || 'solid'}`,
        borderTopWidth: `${this.width}px`,
        borderTopColor: this.lineColor
      }

      if (!this.lineGradient) {
        return style
      }

      return {
        ...style,
        borderTopColor: 'transparent',
        borderImageSlice: 1,
        borderImageSource: this.lineGradient
      }
    },
    backgroundDivider () {
      const color = encodeURIComponent(this.lineColor)
      return {
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='26' height='20' viewBox='0 0 26 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${this.dividerConfig.backgroundImage}' fill='${color}'/%3E%3C/svg%3E%0A")`,
        backgroundRepeat: 'repeat-x',
        height: '25px',
        width: '100%'
      }
    },
    shadowDivider () {
      return {
        boxShadow: `0px 15px 10px -15px ${this.lineColor}`
      }
    }
  }
}
</script>
